import { getClient } from '../../../governanceBridge.js'
import { CHAT_CONFIG } from './config.js'

// Governance Supabase client for chat reads/writes. Returns null in
// environments that don't have governance configured (editor running
// in a non-federated mode) — call-sites must feature-gate on null.
export const chatClient = () => getClient(CHAT_CONFIG.projectName)

export const chatAvailable = () => !!chatClient()
